import axiosInstances from '../utils/axiosInstances';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

class RESTAddressTypesService {
  #dispatchQoreAxiosInstance;

  constructor() {
    this.#dispatchQoreAxiosInstance = axiosInstances({
      baseURL: process.env.REACT_APP_DISPATCH_QORE_API,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY
      },
      withCredentials: true
    });
  }

  /**
   * Returns a list of all address types from the DB or a redis cache
   * with a 10 min ttl
   * @returns {Promise<AxiosResponse>}
   */
  async getAddressTypes() {
    const response = await this.#dispatchQoreAxiosInstance.get('/get-address-types');
    return response.data;
  }
}

export default RESTAddressTypesService;
